module.exports = __webpack_public_path__ + "assets/img/rechirp-off.f8732017.svg";